<template>
  <div class="mp_card_buy" @click="cilckItem(id)">
    <div class="mp_card_buy_tip">
      <img
        src="@/assets/images/icon-buy-type.png"
        :class="item.tip ? 'mp_card_buy_tip_img' : 'mp_card_buy_tip_img_none'"
      />
      <div
        class="mp_card_buy_context"
        :style="
          isActive ? 'box-shadow: 0 1px 3px 1px rgba(64, 158, 255, 0.6)' : ''
        "
      >
        <div class="mp_card_buy_top">
          <div class="price_content">
            <div class="left_content">
              <div class="price_content_top">
                <div class="left_content_top">{{ item.title }}</div>
                <div class="left_content_bottom">{{ item.desc }}</div>
              </div>
              <div class="price_content_bottom"></div>
            </div>
            <div class="right_content">
              <div class="content_left_big_top">
                <div class="content_left_big">￥{{ item.salePrice }}</div>
                <div class="content_right_big">/月</div>
              </div>
              <div class="price_content_bottom">
                <div v-if="item.costPrice !== null" class="content_left">￥{{ item.costPrice }}</div>
                <div v-if="item.costPrice !== null" class="content_right">/月</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mp_card_buy_content">{{ item.explain }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      defalut: function() {
        return {};
      }
    },
    isActive: {
      type: Boolean,
      default: true
    },
    cilckItem: {
      type: Function,
      default: function(id) {}
    },
    id: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="less" scoped>
.mp_card_buy {
  height: 156px;
  width: 100%;
  color: #ffffff;
  .mp_card_buy_tip {
    .mp_card_buy_tip_img {
      height: 29px;
      float: right;
      margin: 0 -4px;
      margin-top: 7px;
    }
    .mp_card_buy_tip_img_none {
      display: none;
    }
    .mp_card_buy_context:hover {
      box-shadow: 0 1px 3px 1px rgba(64, 158, 255, 0.6);
    }
    .mp_card_buy_context {
      border-radius: 7px;
      box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
      background: #5bb7fe;
      cursor: pointer;
      .mp_card_buy_top {
        height: 116px;
        padding-top: 37px;
        .price_content {
          width: 100%;
          height: 69px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding-bottom: 10px;
          .left_content {
            .price_content_top {
              height: 48px;
              .left_content_top {
                font-size: 20px;
                font-weight: bold;
              }
              .left_content_bottom {
                font-size: 14px;
              }
            }
            .price_content_bottom {
              height: 21px;
            }
          }
          .right_content {
            padding-right: 15px;
            .price_content_bottom {
              height: 21px;
              display: flex;
              justify-content: flex-end;
              .content_left {
                font-size: 17px;
                float: right;
                text-decoration: line-through;
              }
              .content_right {
                font-size: 10px;
                margin-top: 3px;
                margin-left: 2px;
                float: right;
              }
            }
            .content_left_big_top {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 48px;

              .content_left_big {
                font-size: 40px;
                height: 40px;
                margin-bottom: 16px;
              }
              .content_right_big {
                font-size: 20px;
                height: 20px;
                margin-top: 3px;
                margin-left: 2px;
              }
            }
          }
        }
      }
      .mp_card_buy_content {
        height: 40px;
        background: #ffffff;
        color: #5bb7fe;
        font-size: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        letter-spacing: 5px;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
      }
    }
  }
}
</style>
